const ChangeLanguageIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path d='M8 7h8M8 12h8M8 17h8' stroke='currentColor' strokeWidth='1.6' />
  </svg>
);

export default ChangeLanguageIcon;
